<template>
  <div>
    <ModalUpdateRRIM v-if="this.$store.getters.$GetModalCancel.rrimEdit" />
    <ModalViewRRIM
      v-if="this.$store.getters.$GetModalCancel.rrimView"
      :homologation="homologation"
      :role="role"
    />

    <ModalHomologa v-if="ModalHomologa">
      <div class="modal-header">
        <h3><strong>N° RRIM:</strong> {{ this.RRIM.rrim }}</h3>
        <h3><strong>Molde:</strong> {{ this.RRIM.molde }}</h3>
        <h3><strong>Cliente:</strong> {{ this.RRIM.Cliente }}</h3>
        <h3><strong>Criado por:</strong> {{ this.RRIM.criado }}</h3>
      </div>

      <div class="modal-comentario">
        <span><strong>Comentario:</strong></span>
        <textarea
          style="width: 100%; resize: none"
          class="textarea_hom"
          v-model="ComentarioHomolgacao"
          rows="7"
        >
        </textarea>
      </div>

      <div class="modal-buttons">
        <button class="btn1 aprovar" @click="showModalConfirmacao(true)">
          Aprovar
        </button>
        <button class="btn1 reprovar" @click="showModalConfirmacao(false)">
          Reprovar
        </button>
        <button class="btn1 cancelar" @click="fecharModalHomolacao">
          Cancelar
        </button>
      </div>

      <div class="modal-confirmacao" v-if="showConfirmacao">
        <span v-if="statusHomologacao"
          >Sim, eu desejo confirmar a
          <strong style="color: var(--green)">APROVAÇÃO</strong> desta
          RRIM</span
        >
        <span v-if="!statusHomologacao"
          >Sim, eu desejo confirmar a
          <strong style="color: var(--red)">REPROVACAO</strong> desta RRIM</span
        >
        <div class="confirmacao-buttons">
          <!-- <button class="btn-modal sem-borda" @click="fecharModalHomolacao">
            Cancelar
          </button> -->
          <button
            class="btn-modal"
            @click="homologar(statusHomologacao, this.RRIM.rrim)"
          >
            Sim, confirmar
          </button>
        </div>
      </div>
    </ModalHomologa>
    <div class="tools">
      <div class="subjectfather">
        <div class="subject">
          <h3>Relatórios em homologação</h3>
        </div>
      </div>
      <div class="toolscontainer">
        <ModalRRIM :role="role_description" />
        <div class="filters">
          <div class="searchInput">
            <div class="icon"></div>
            <div>
              <input
                style="border: none !important"
                type="text"
                placeholder="Pesquisar..."
                v-model="value_filter"
              />
            </div>
          </div>
          <div>
            <div class="filter-content">
              <img
                src="../../../src/static/icons/filter.svg"
                alt="filter_icon"
              />
              <div class="content-intern">
                <select v-model="filter_attr">
                  <option value="Todos">Todos</option>
                  <option value="id">Id</option>
                  <option value="client">Cliente</option>
                  <option value="mold">Molde</option>
                </select>
              </div>
            </div>
          </div>
          <button class="btn-filter" @click="filter">Filtrar</button>
        </div>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <td colspan="col">ID</td>
          <td colspan="col">Molde</td>
          <td colspan="col">Cliente</td>
          <td colspan="col">Molde Família</td>
          <td colspan="col">Chegada do Molde</td>
          <td colspan="col">Abertura do Molde</td>
          <td colspan="col">Criado por:</td>
          <td colspan="col">Opções</td>
        </tr>
      </thead>
      <tbody class="tb-content">
        <tr v-for="tryouts in filtrarInput()" :key="tryouts.id">
          <td data-label="RRIM" class="tdTitle">{{ tryouts.rrim }}</td>
          <td data-label="Molde">{{ tryouts.molde }}</td>
          <td data-label="Cliente">{{ tryouts.Cliente }}</td>
          <td data-label="molde">
            <span v-if="tryouts.molde_family === true">
              <div class="checked"></div
            ></span>
            <span v-else> </span>
          </td>
          <td data-label="Data de Criação">{{ tryouts.Data }}</td>
          <td data-label="Data de Abertura">{{ tryouts.DataAbertura }}</td>

          <td data-label="Criado por:">
            {{ tryouts.criado }} <br />
            {{ tryouts.cargo }}
          </td>
          <td data-label="Opções">
            <div class="buttons-group">
              <button
                class="button3"
                @click="modal_view(tryouts.rrim)"
                v-if="!$store.state.removeicons"
              >
                <div class="viewicon"></div>
                <span class="tooltip">Visualizar</span>
              </button>
              <button
                class="button3"
                type="button"
                @click="modal_view(tryouts.rrim)"
                v-if="$store.state.removeicons"
              >
                <div
                  class="viewicon"
                  style="
                    background-image: url(../../static/icons/viewrrimwhite.svg) !important;
                  "
                ></div>
                <span class="tooltip">Visualizar</span>
              </button>
              <button
                class="button6"
                type="button"
                @click="modal_edit(tryouts.rrim)"
                v-if="status_new_table && role !== 'eng_admin'"
              >
                <div class="editicon"></div>
                <span class="tooltip">Editar</span>
              </button>
              <button
                class="button4"
                type="button"
                @click="AbrirModalHomologacao(tryouts)"
                v-if="role === 'eng_admin' && !$store.state.removeicons"
              >
                <div class="homologationicon"></div>
                <span class="tooltip">Homologar</span>
              </button>
              <button
                class="button4"
                type="button"
                @click="AbrirModalHomologacao(tryouts)"
                v-if="role === 'eng_admin' && $store.state.removeicons"
              >
                <div
                  class="homologationicon"
                  style="
                    background-image: url(../../static/icons/check-square_white.svg) !important;
                  "
                ></div>
                <span class="tooltip">Homologar</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <h2 v-if="filtrarInput().length === 0" class="warning">
      Não há nada para ser mostrado
    </h2>
    <div class="footer">
      <button @click="init" v-if="currentPage !== 0" class="btn-pagination">
        <div class="arrow-firstpage"></div>
        <p>Inicio</p>
      </button>
      <button @click="back" v-if="currentPage !== 0" class="btn-pagination">
        <div class="arrow-left"></div>
        <p>Voltar</p>
      </button>
      <span class="count" v-if="filtrarInput().length != 0">
        Página {{ countPage }} de {{ countTotal }}</span
      >
      <button
        @click="next"
        class="btn-pagination"
        v-if="countTotal > 1 && countPage < countTotal"
      >
        <p>Próximo</p>
        <div class="arrow-right"></div>
      </button>
    </div>
  </div>
</template>

<script>
import TableLite from "./../../components/Tables/Table-Simple.vue";
import {
  GetFindDataByIdRRIM,
  GetFindDataRRIMByAttr,
} from "../../controllers/RRIM/GetFindDataByIdRRIM";
import ModalViewRRIM from "../../components/Modais/ModalRRIM/ModalViewRRIM.vue";
import ModalUpdateRRIM from "../../components/Modais/ModalRRIM/ModalUpdateRRIM.vue";
import { GetAllRrimInRevisao } from "../../controllers/RRIM/GetAllRrimInRevisao";
import { api } from "../../http/index";
import ModalHomologa from "@/components/Modais/ModalHomologa.vue";
import dayjs from "dayjs";
import ModalRRIM from "../../components/Modais/ModalRRIM/ModalRRIM.vue";

// Orden de dados em forma Crescente
const sampleData1 = (offst, limit) => {
  offst = offst + 1;

  let data = [];
  for (let i = offst; i <= limit; i++) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

//Orden de dados em forma Decrescente
const sampleData2 = (offst, limit) => {
  let data = [];
  for (let i = limit; i > offst; i--) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

export default {
  name: "App",
  components: {
    TableLite,
    ModalViewRRIM,
    ModalUpdateRRIM,
    ModalHomologa,
    ModalRRIM,
  },

  props: {
    configInputs: Number,
    role_description: String,
  },
  async created() {
    await this.requestList();
  },

  mounted() {
    this.role = this.$store.state.user.nivel_de_acesso.descricao;
  },

  data() {
    return {
      homologation: true,
      statusHomologacao: false,
      showConfirmacao: false,
      value_filter: null,
      filter_attr: "Todos",
      currentPage: 0,
      countPage: 1,
      datalength: 0,
      isActiveAprovado: false,
      isDisabledAprovado: false,
      isActiveReprovado: false,
      isDisabledReprovado: false,
      role: String,
      Data: [],
      RRIM: Number,
      ComentarioHomolgacao: null,
      ModalHomologa: false,
      Homolagacao: null,
      VerifyRRIM: false,
      VerifyEditRRIM: this.$store.getters.$GetModalCancel.rrimEdit,
      isLoading: false,
      valueSearch: "",
      id_rrim_homo: "",
      rows: [],
      rowsNowOk: [],
      totalRecordCount: 0,
      totalRecordCountNok: 0,
      status_new_table: true,
      sortable: {
        order: "id",
        sort: "asc",
      },
      countTotal: 1,
    };
  },

  methods: {
    showModalConfirmacao(valorConfirmacao) {
      this.statusHomologacao = valorConfirmacao;
      this.showConfirmacao = true;
    },

    async homologar(valorConfirmacao, rrim) {
      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (
        this.ComentarioHomolgacao === null ||
        this.ComentarioHomolgacao.length === 0
      ) {
        Toast.fire({
          icon: "success",
          title: "Você deve adicionar um comentário!",
        });
      } else {
        if (valorConfirmacao) {
          await api
            .put(`/rrim/homologation/${rrim}`, {
              status: 2,
              comentario: this.ComentarioHomolgacao,
            })
            .then((res) => {
              Toast.fire({
                icon: "success",
                title: "RRIM Aprovada!",
              });
            });
        } else {
          await api
            .put(`/rrim/homologation/${rrim}`, {
              status: 3,
              comentario: this.ComentarioHomolgacao,
            })
            .then((res) => {
              Toast.fire({
                icon: "success",
                title: "RRIM Reprovada!",
              });
            });
        }

        window.location.reload();
      }
    },

    async requestList() {
      this.$store.commit("SetLoadingPattern", true); // insere o loading
      this.Data = [];
      const result = await GetAllRrimInRevisao(this.currentPage, 10, 1);
      await result.list.map((element) => {
        this.Data.push({
          rrim: element.ID,
          criado: `${element.homologacao[0].created_user.nome}`,
          cargo: element.homologacao[0].created_user.cargo,
          molde: element.MOLDE,
          molde_family: element.molde_familia,
          Cliente: element.CLIENTE,
          Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
          DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
          DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
        });
      });
      if (result.countTotal > 10) {
        this.countTotal = result.countTotal / 10;
      } else {
        this.countTotal = 1;
      }
      if (!Number.isInteger(this.countTotal)) {
        const npage = Math.ceil(this.countTotal);
        this.countTotal = npage;
      }
      this.datalength = result.length;
      await this.doSearch(0, 10, "description", "asc");
      this.$store.commit("SetLoadingPattern", false); // insere o loading
    },

    async init() {
      this.currentPage = 0;
      this.countPage = 1;
      await this.requestList();
    },

    async back() {
      this.currentPage = this.currentPage - 10;
      this.countPage--;
      await this.requestList();
    },

    async next() {
      this.currentPage = this.currentPage + 10;
      this.countPage++;
      await this.requestList();
    },

    async modal_view(rrim) {
      const result = await GetFindDataByIdRRIM(rrim);
      await this.$store.commit("MutationGetFindDataRRIM", result.data);
      this.$store.commit("MutationSetCancelModalViewRRIM", true);
    },
    async modal_edit(rrim) {
      const result = await GetFindDataByIdRRIM(rrim);
      await this.$store.commit("MutationGetFindDataRRIM", result.data);
      this.$store.commit("MutationSetCancelModalEditRRIM", true);
    },
    async AbrirModalHomologacao(rrim) {
      this.RRIM = rrim;
      this.ModalHomologa = true;
    },
    async fecharModalHomolacao() {
      this.showConfirmacao = false;
      this.isActiveAprovado = false;
      this.isDisabledAprovado = false;
      this.ComentarioHomolgacao = "";
      this.ModalHomologa = false;
      return;
    },

    homologacao(value) {
      if (value) {
        this.isActiveAprovado = true;
        this.isDisabledAprovado = false;
      } else {
        this.isActiveAprovado = false;
        this.isDisabledAprovado = true;
      }

      this.Homolagacao = value;
    },
    async ConfirmHomologacao(rrim) {
      if (this.Homolagacao == null || this.ComentarioHomolgacao == null) {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "info",
          title: "Campos vazios ou não selecionados!",
        });

        return;
      }
      if (this.Homolagacao === true) {
        const result = await api.put(`/rrim/homologation/${rrim}`, {
          status: 2,
          comentario: this.ComentarioHomolgacao,
        });
        if (result.status === 200) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Aprovado com Sucesso!",
          });

          this.isActiveAprovado = false;
          this.isDisabledAprovado = false;
          this.ComentarioHomolgacao = "";
          window.location.reload();
        }
      } else {
        const result = await api.put(`/rrim/homologation/${rrim}`, {
          status: 3,
          comentario: this.ComentarioHomolgacao,
        });
        if (result.status === 200) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Reprovado com Sucesso!",
          });

          this.isActiveAprovado = false;
          this.isDisabledAprovado = false;
          this.ComentarioHomolgacao = "";
          window.location.reload();
        }
      }
    },
    // Montagem de filro e limite do checklist
    async doSearch(offset, limit, order, sort) {
      if (!this.isLoading) {
        this.isLoading = true;
      }

      this.status_new_table = false;
      this.status_new_table = true;

      setTimeout(() => {
        const limitePre = this.datalength;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rows = sampleData1(offset, limit);
        } else {
          this.rows = sampleData2(offset, limit);
        }

        this.totalRecordCount = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    // Montagem de filro e limite de Itens Não/Ok
    doSearch_NaoOK(offset, limit, order, sort) {
      this.isLoadingNok = true;
      setTimeout(() => {
        const limitePre = this.Data.length;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rowsNowOk = sampleData1(offset, limit);
        } else {
          this.rowsNowOk = sampleData2(offset, limit);
        }

        this.totalRecordCountNok = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    ReformDate(date) {
      const data = dayjs(date).add(1, "day").format("DD/MM/YYYY");

      return data;
    },

    async exportar(id) {
      const toast = await this.$swal
        .fire({
          title: "Deseja exportar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      this.$router.push({ path: "/export", query: { id } });
    },

    filtrarInput() {
      let list = [];
      this.valueSearch = this.valueSearch.toLocaleLowerCase();
      list = this.Data.filter((filter) => {
        let rrimCodeFormated = String(filter.rrim);
        return (
          rrimCodeFormated.toLowerCase().match(this.valueSearch) ||
          filter.molde.toLowerCase().match(this.valueSearch) ||
          filter.Cliente.toLowerCase().match(this.valueSearch) ||
          filter.criado.toLowerCase().match(this.valueSearch)
        );
      });
      return list;
    },

    async filter() {
      if (this.filter_attr == "Todos") {
        await this.requestList();
      } else {
        const result = await GetFindDataRRIMByAttr(
          this.filter_attr,
          this.value_filter,
          1
        );

        this.Data = [];
        await result.data.map((element) => {
          this.Data.push({
            rrim: element.ID,
            criado: `${element.homologacao[0].created_user.nome}`,
            cargo: element.homologacao[0].created_user.cargo,
            molde: element.MOLDE,
            Cliente: element.CLIENTE,
            Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
            DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
            DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
          });
        });
      }
    },
  },
};
</script>
<style scoped>
.table thead tr td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.table thead tr td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.tools {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.subjectfather {
  display: flex;
  align-items: center;
  justify-content: center;
}

.subject {
  background-color: var(--gray_header);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
}

.subject h3 {
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 1rem;
}

.toolscontainer {
  display: flex;
  flex-wrap: wrap;
}

input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}
img {
  border-style: none;
}

.searchInput {
  background-color: var(--white);
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid var(--gray_homologation);
  height: 2.65rem;
  transition: border-color 0.3s ease-in-out;
}

.searchInput:focus-within {
  border: 1px solid var(--green);
}

.searchInput:hover {
  outline: 1px solid var(--inputColor);
}

.btn-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background-color: var(--green);
  padding: 0.5rem 0.8rem;
  color: var(--white);
  border-radius: 0.5rem;
}

.btn-pagination p {
  font-size: 1rem;
}

.btn-pagination:hover {
  border: 3px solid var(--green);
  background-color: white;
  color: var(--green);
}

.arrow-right {
  background-image: url(../../static/icons/arrow-right.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
}

.arrow-left {
  background-image: url(../../static/icons/arrow-left.svg);
  background-repeat: no-repeat;
  background-position: right;
  background-size: 100%;
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
}

.arrow-firstpage {
  background-image: url(../../static/icons/first_page_white.svg);
  background-repeat: no-repeat;
  background-position: right;
  background-size: 100%;
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
}

.btn-pagination:hover .arrow-right {
  background-image: url(../../static/icons/arrow-right-green.svg);
}

.btn-pagination:hover .arrow-left {
  background-image: url(../../static/icons/arrow-left-green.svg);
}

.btn-pagination:hover .arrow-firstpage {
  background-image: url(../../static/icons/first_page-green.svg);
}

.filter-content {
  height: 2.65rem !important;
  border-radius: 10px !important;
}

.filter-content:hover {
  outline: 1px solid var(--inputColor);
}

.filter-content:focus-within {
  border: 1px solid var(--green);
}
.filter-content .content-intern {
  width: 80%;
  padding: 0 0 0 5px;
}

.filter-content .content-intern select {
  width: 100%;
  border: none;
  font-size: 15px;
  text-align: left;
  color: #9a9a9a;
  font-family: Poppins, sans-serif;
  padding: 0rem 2rem 0rem 0.5rem;
  background-color: white !important;
}

.content-intern select option {
  color: var(--font_color);
  background-color: #ffffff;
  border-radius: 5rem !important;
}

.filter-content .content-intern select option:hover {
  background-color: #e0e0e0 !important;
}

.filter-content .content-intern select option:checked {
  background-color: var(--font_color);
  border-radius: 5rem !important;
  color: white !important;
}

.filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.btn-filter {
  width: 70px;
  height: 2.65rem;
  background-color: var(--green);
  color: #fff;
  border-radius: 0.5rem;
  font-family: Poppins, sans-serif;
}

.btn-filter:hover {
  color: #fff;
  background-color: var(--green_hover);
}

.btn-filter:focus {
  color: #fff;
  background-color: var(--green_focus);
}

.searchInput .icon {
  background-image: url(../../static/icons/search.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.5rem 0.5rem 0.5rem 0.3rem;
}

.searchInput input {
  width: 19rem;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  border-radius: 5px;
  height: 98% !important;
}

.searchInput:focus-within .icon {
  background-image: url(../../static/icons/search_green.svg);
  transition: 0.15s ease-in-out;
}

.searchInput ::placeholder {
  color: var(--inputColor);
  font-family: Poppins, sans-serif;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.table {
  border-radius: 8px;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  opacity: 0;
  animation: fadeIn 1s ease forwards !important;
}

.table thead td {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
}

.table tbody td {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

table {
  border-collapse: collapse;
  max-height: 400px;
  width: 100%;
  font-family: "Poppins", Helvetica, sans-serif;
  margin-top: 1.5rem;
}

thead {
  font-size: 16px;
  background-color: var(--gray_header);
  color: var(--font_color);
  font-family: Poppins, sans-serif;
  font-weight: 400;
}

th {
  padding: 10px;
  border-top: none;
  border-left: none;
  font-family: Poppins, sans-serif;
}

td {
  text-align: center;
  padding: 10px;
  border-left: none;
  font-size: 14px;
}

.checked {
  background-image: url(../../static/icons/checked.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0 auto;
}

.viewicon {
  background-image: url(../../static/icons/viewrrim.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
}

.tooltip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  font-family: "Poppins", sans-serif;
  transform: translateX(-50%);
  background-color: var(--font_color);
  color: #fff;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 14px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s;
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
}

.button3:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.button4:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.button5:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.button6:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.exporticon {
  background-image: url(../../static/icons/exportrrim.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
}

.btn {
  display: flex;
  gap: 1rem;
  margin-left: 16px;
  margin-bottom: -11px;
}

.btn button {
  width: 22px;
  height: 22px;
  background: transparent;
}

.input-tamanho {
  width: 100%;
  height: 40px;
  border: none;
  padding: 3px;
}

.maozinha {
  cursor: pointer;
}

.red {
  color: var(--red) !important;
}

.error {
  background: var(--redTransparent);
}

.buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.button3 {
  position: relative;
  background: var(--white);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button3:focus {
  background: var(--font_color);
  .viewicon {
    background-image: url(../../static/icons/viewrrimwhite.svg);
  }
}

.button4,
.button6 {
  position: relative;
  background: var(--white);
  color: var(--blue);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.homologationicon {
  background-image: url(../../static/icons/checked.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
}

.editicon {
  background-image: url(../../static/icons/edit_simple.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
  background-size: 90%;
}

.button4:focus {
  background: var(--font_color);
  .homologationicon {
    background-image: url(../../static/icons/checkedwhite.svg);
  }
}

.button6:focus {
  background: var(--font_color);
  .editicon {
    background-image: url(../../static/icons/edit_simple_white.svg);
  }
}

.filter-content {
  height: 2.8rem;
  width: 200px;
  background-color: var(--white);
  display: flex;
  align-items: center;
  border: 1px solid var(--gray_text);
  border-radius: 5px;
  padding: 0 0 0 5px;
}
.button5 {
  position: relative;
  background: var(--white);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button5:focus {
  background: var(--font_color);
  color: var(--white);
  .exporticon {
    background-image: url(../../static/icons/exportrrimwhite.svg);
    background-repeat: no-repeat;
    background-position: center;
    width: 1.5rem;
    height: 1.5rem;
  }
}

.footer {
  display: flex;
  justify-content: right;
  font-family: "Poppins", sans-serif;
  gap: 5px;
  align-items: center;
  height: 4rem;
}

.count {
  font-family: "Poppins", sans-serif;
}

.warning {
  font-size: 1.3rem;
  margin: 1rem 0rem;
}

@media (max-width: 1040px) {
  .subjectfather {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .inputSearch {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .searchInput input {
    width: 100%;
  }

  .table thead {
    clip: react(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  tbody {
    background: none;
  }

  .table tr {
    border: 1px solid var(--gray_text);
    border-radius: 7px;
    display: block;
    margin-bottom: 2rem;
    padding: 0;
    background: var(--white);
  }

  .table td {
    display: block;
    font-size: 1rem;
    text-align: right;
  }

  .table td::before {
    content: attr(data-label);
    float: left;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.9rem;
  }

  .buttons-group {
    justify-content: flex-end;
  }

  .checked {
    margin: 0;
    margin-left: auto;
  }

  .viewicon {
    width: 1.7rem;
  }

  .exporticon {
    width: 1.7rem;
  }
}

.modal-header {
  padding: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.modal-buttons {
  display: flex;
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  width: 100%;
  flex-direction: row-reverse;
}

.btn1 {
  border: 2px solid;
  background-color: white;
  color: var(--font_color);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn1.aprovar {
  border-color: var(--green);
  color: var(--green);
}

.btn1.aprovar:hover {
  background-color: var(--green);
  color: white;
}

.btn1.reprovar {
  border-color: var(--red);
  color: var(--red);
}

.btn1.reprovar:hover {
  background-color: var(--red);
  color: white;
}

.btn1.cancelar {
  border-color: orange;
  color: orange;
}

.btn1.cancelar:hover {
  background-color: orange;
  color: white;
}

.modal-comentario {
  padding: 1rem;
}

.textarea_hom {
  width: 100% !important;
  border-radius: 10px !important;
  border: 1px solid #d9d9d9;
  padding: 0.5rem;
  color: var(--font_color);
}

.textarea_hom:hover {
  border: 1.5px solid var(--green);
  color: green;
}

.sem-borda {
  font-weight: 600;
  color: var(--orange);
  background-color: transparent;
  text-decoration-line: underline;
}

.modal-comentario textarea {
  border-radius: 0.25rem;
  padding: 0.5rem;
}

.modal-confirmacao {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirmacao-buttons {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
}

.btn-modal {
  border: 2px solid;
  border-color: var(--font_color);
  color: var(--font_color);
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-modal:hover {
  background-color: var(--font_color);
  color: white;
}
</style>
